<template>
  <div id="filter-modal" class="mt-4">
    <v-row class="mx-9 my-8">
      <v-select
        filled
        dense
        hide-details
        :items="filterOptions.cities"
        label="Creation Location"
        color="secondary"
        id="filter-location"
        v-model="filterParams.location"
      ></v-select>
    </v-row>
    <v-row class="mx-9">
      <v-select
        filled
        dense
        :items="filterOptions.used"
        label="Code Used Y/N"
        id="filter-code"
        color="secondary"
        v-model="filterParams.used"
      ></v-select>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import FilterParams from '@/mixins/FilterParams';

export default {
  mixins: [FilterParams],
  methods: {
    ...mapMutations({
      _setFilterOptions: 'filters/setKeyFilterOptions',
    }),
  },
  computed: {
    ...mapGetters({
      _filterOptions: 'filters/getKeyFilterOptions',
    }),
    filterOptions: {
      get() {
        return this._filterOptions;
      },
      set() {
        this._setFilterOptions();
      },
    },
  },
};
</script>
